import type { MultiIdMap } from '@/common/di/BindHelper'

export class MultiBindingService<Tid extends string> {
  constructor(public readonly multiIdToIds: MultiIdMap<Tid>) {}
}
